import React from 'react';
import { Config } from 'types';
import { Email, GitHub, LinkedIn, Resume } from 'icons';

const config: Config = {
  name: {
    display: 'Rahul Jalan',
    aria: 'My name is Rahul Jalan',
  },
  title: {
    display: 'Software Developer',
    aria: 'I am a software developer',
  },
  buttons: [
    {
      display: 'GitHub',
      aria: 'Visit my GitHub profile',
      icon: <GitHub />,
      href: 'https://github.com/rahuljalan23/',
    },
    {
      display: 'LinkedIn',
      aria: 'Visit my LinkedIn profile',
      icon: <LinkedIn />,
      href: 'https://www.linkedin.com/in/rahuljalan23/',
    },
    {
      display: 'Resume',
      aria: 'View my resume in Google Drive',
      icon: <Resume />,
      href: 'https://drive.google.com/file/d/1yg9efaiA5AEynae3r7n01pNcsR1NcZNS/view?usp=sharing/',
    },
    {
      display: 'Email',
      aria: 'Send me an email',
      icon: <Email />,
      href: 'mailto:rahuljalan23.rj@gmail.com',
    },
  ],
};

export default config;
